/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const noticeRouter = {
	path: '/noticeV2',
	component: Layout,
	redirect: 'noticeLayout',
	name: '通知',
	id: 2100000,
	meta: {
		title: '通知',
		icon: 'component',
		roles: [2100000]
	},
	children: [
		{
			path: 'noticeLayout',
			component: LayoutView,
			name: '自动通知',
			id: 2101000,
			meta: {
				title: '自动通知',
				roles: [2101000]
			},
			children: [
				{
					path: 'verificationCode',
					component: () =>
						import(
							'@/leniuview/noticeV2/autoNotice/verificationCode/verificationCode'
						),
					name: '验证码',
					id: 2101100,
					meta: { title: '验证码', roles: [2101100] },
					children: [
						{
							path: 'note',
							component: () =>
								import('@/leniuview/noticeV2/autoNotice/verificationCode/note'),
							name: '短信',
							meta: { title: '短信', roles: [2101100], noCache: true },
							hidden: true
						}
					]
				},
				{
					path: 'orderMake',
					component: () =>
						import('@/leniuview/noticeV2/autoNotice/orderMake/orderMake'),
					name: '下单制作',
					id: 2101200,
					meta: { title: '下单制作', roles: [2101200] }
				},
				{
					path: 'yue',
					component: () => import('@/leniuview/noticeV2/autoNotice/yue/index'),
					name: '余额变动',
					id: 2101300,
					meta: { title: '余额变动', roles: [2101300] }
				},
				{
					path: 'takeMeals',
					component: () =>
						import('@/leniuview/noticeV2/autoNotice/takeMeals/index'),
					name: '取餐',
					id: 2101400,
					meta: { title: '取餐', roles: [2101400] }
				},
				{
					path: 'jiucuoRefund',
					component: () =>
						import('@/leniuview/noticeV2/autoNotice/jiucuoRefund/index'),
					name: '退单退款',
					id: 2101500,
					meta: { title: '退单退款', roles: [2101500] }
				},
				{
					path: 'buffet',
					component: () =>
						import('@/leniuview/noticeV2/autoNotice/buffet/index'),
					name: '自助餐',
					id: 2101600,
					meta: { title: '自助餐', roles: [2101600] }
				},
				{
					path: 'menuaiRegister',
					component: () =>
						import('@/leniuview/noticeV2/autoNotice/menuaiRegister/index'),
					name: '菜品识别',
					id: 2101910,
					meta: { title: '菜品识别', roles: [2101910] }
				},
				{
					path: 'supplierInform',
					component: () =>
						import('@/leniuview/noticeV2/autoNotice/supplierInform/index'),
					name: '供货商',
					id: 2101920,
					meta: { title: '供货商', roles: [2101920] }
				}
				// {
				//   path: "health",
				//   component: () => import("@/leniuview/noticeV2/autoNotice/health/index"),
				//   redirect: "health/note",
				//   name: "健康中心",
				//   id: 2101700,
				//   meta: { title: "健康中心", roles: [2101700] },
				//   children: [
				//     {
				//       path: "note",
				//       component: () =>
				//         import("@/leniuview/noticeV2/autoNotice/health/note"),
				//       name: "短信",
				//       meta: { title: "短信", roles: [2101710], noCache: true },
				//       hidden: true,
				//     },
				//     {
				//       path: "weChat",
				//       component: () =>
				//         import("@/leniuview/noticeV2/autoNotice/health/weChat"),
				//       name: "微信小程序",
				//       meta: { title: "微信小程序", roles: [2101720], noCache: true },
				//       hidden: true,
				//     },
				//     {
				//       path: "gongzhonghao",
				//       component: () =>
				//         import("@/leniuview/noticeV2/autoNotice/health/gongzhonghao"),
				//       name: "微信公众号",
				//       meta: { title: "微信公众号", roles: [2101730], noCache: true },
				//       hidden: true,
				//     },
				//     {
				//       path: "dingTalk",
				//       component: () =>
				//         import("@/leniuview/noticeV2/autoNotice/health/dingTalk"),
				//       name: "钉钉",
				//       meta: { title: "钉钉", roles: [2101740], noCache: true },
				//       hidden: true,
				//     },
				//   ]
				// },{
				//   path: "entranceGuard",
				//   component: () => import("@/leniuview/noticeV2/autoNotice/entranceGuard/index"),
				//   redirect: "entranceGuard/note",
				//   name: "门禁",
				//   id: 2101800,
				//   meta: { title: "门禁", roles: [2101800] },
				//   children: [
				//     {
				//       path: "note",
				//       component: () =>
				//         import("@/leniuview/noticeV2/autoNotice/entranceGuard/note"),
				//       name: "短信",
				//       meta: { title: "短信", roles: [2101810], noCache: true },
				//       hidden: true,
				//     },
				//     {
				//       path: "weChat",
				//       component: () =>
				//         import("@/leniuview/noticeV2/autoNotice/entranceGuard/weChat"),
				//       name: "微信小程序",
				//       meta: { title: "微信小程序", roles: [2101820], noCache: true },
				//       hidden: true,
				//     },
				//     {
				//       path: "gongzhonghao",
				//       component: () =>
				//         import("@/leniuview/noticeV2/autoNotice/entranceGuard/gongzhonghao"),
				//       name: "微信公众号",
				//       meta: { title: "微信公众号", roles: [2101830], noCache: true },
				//       hidden: true,
				//     },
				//     {
				//       path: "dingTalk",
				//       component: () =>
				//         import("@/leniuview/noticeV2/autoNotice/entranceGuard/dingTalk"),
				//       name: "钉钉",
				//       meta: { title: "钉钉", roles: [2101840], noCache: true },
				//       hidden: true,
				//     },
				//   ]
				// },{
				//   path: "machine",
				//   component: () => import("@/leniuview/noticeV2/autoNotice/machine/index"),
				//   redirect: "machine/note",
				//   name: "设备",
				//   id: 2101900,
				//   meta: { title: "设备", roles: [2101900] },
				//   children: [
				//     {
				//       path: "note",
				//       component: () =>
				//         import("@/leniuview/noticeV2/autoNotice/machine/note"),
				//       name: "短信",
				//       meta: { title: "短信", roles: [2101910], noCache: true },
				//       hidden: true,
				//     },
				//     {
				//       path: "weChat",
				//       component: () =>
				//         import("@/leniuview/noticeV2/autoNotice/machine/weChat"),
				//       name: "微信小程序",
				//       meta: { title: "微信小程序", roles: [2101920], noCache: true },
				//       hidden: true,
				//     },
				//     {
				//       path: "gongzhonghao",
				//       component: () =>
				//         import("@/leniuview/noticeV2/autoNotice/machine/gongzhonghao"),
				//       name: "微信公众号",
				//       meta: { title: "微信公众号", roles: [2101930], noCache: true },
				//       hidden: true,
				//     },
				//     {
				//       path: "dingTalk",
				//       component: () =>
				//         import("@/leniuview/noticeV2/autoNotice/machine/dingTalk"),
				//       name: "钉钉",
				//       meta: { title: "钉钉", roles: [2101940], noCache: true },
				//       hidden: true,
				//     },
				//   ]
				// },
			]
		},
		{
			path: 'noticeV2Layout',
			component: LayoutView,
			name: '群发通知',
			id: 2102000,
			meta: {
				title: '群发通知',
				roles: [2102000]
			},
			children: [
				{
					path: 'noticeFabu',
					component: () =>
						import('@/leniuview/noticeV2/batchNotice/noticeFabu'),
					name: '通知发布',
					id: 2102100,
					meta: { title: '通知发布', roles: [2102100] }
				},
				{
					path: 'noticeTemplate',
					component: () =>
						import('@/leniuview/noticeV2/batchNotice/noticeTemplate'),
					name: '通知模板',
					redirect: 'noticeTemplate/note',
					id: 2102200,
					meta: { title: '通知模板', roles: [2102200] },
					children: [
						{
							path: 'note',
							component: () => import('@/leniuview/noticeV2/batchNotice/note'),
							name: '短信',
							meta: { title: '短信', roles: [2102200], noCache: true },
							hidden: true
						},
						{
							path: 'weChat',
							component: () =>
								import('@/leniuview/noticeV2/batchNotice/weChat'),
							name: '微信小程序',
							meta: { title: '微信小程序', roles: [2102200], noCache: true },
							hidden: true
						},
						{
							path: 'gongzhonghao',
							component: () =>
								import('@/leniuview/noticeV2/batchNotice/gongzhonghao'),
							name: '微信公众号',
							meta: { title: '微信公众号', roles: [2102200], noCache: true },
							hidden: true
						},
						{
							path: 'dingTalk',
							component: () =>
								import('@/leniuview/noticeV2/batchNotice/dingTalk'),
							name: '钉钉',
							meta: { title: '钉钉', roles: [2102200], noCache: true },
							hidden: true
						},
						{
							path: 'weCom',
							component: () =>
								import('@/leniuview/noticeV2/batchNotice/weCom'),
							name: '企业微信',
							meta: { title: '企业微信', roles: [2102200], noCache: true },
							hidden: true
						}
					]
				}
			]
		},
		{
			path: 'echartsTemplate',
			component: () => import('@/leniuview/noticeV2/echartsNotice/index'),
			name: '通知统计',
			redirect: 'echartsTemplate/echarts',
			id: 2103000,
			meta: {
				title: '通知统计',
				roles: [2103000]
			},
			children: [
				{
					path: 'echarts',
					component: () => import('@/leniuview/noticeV2/echartsNotice/echarts'),
					name: '通知统计',
					id: 2103100,
					meta: { title: '通知统计', roles: [2103100] },
					hidden: true
				},
				{
					path: 'noticeHistory',
					component: () =>
						import('@/leniuview/noticeV2/echartsNotice/noticeHistory'),
					name: '通知记录',
					id: 2103200,
					meta: { title: '通知记录', roles: [2103200] },
					hidden: true
				}
			]
		},
		{
			path: 'interNotice',
			component: () => import('@/leniuview/noticeV2/interimNotice/index'),
			name: '临时通知',
			id: 2105000,
			meta: {
				title: '临时通知',
				roles: [2105000]
			}
		},
		{
			path: 'printNote',
			// component: () => import('@/leniuview/notice/print/print'),
			component: () => import('@/leniuview/noticeV2/printRecords'),
			name: '打印信息',
			id: 2104000,
			meta: {
				title: '打印信息',
				noCache: true,
				roles: [2104000]
			}
		},

		// {
		// 	path: 'printDetail',
		// 	component: () => import('@/leniuview/notice/print/detail'),
		// 	name: '打印详情',
		// 	meta: {
		// 		title: '打印详情',
		// 		noCache: true,
		// 		roles: [2104000]
		// 	},
		// 	hidden: true
		// },
		// {
		//   path: 'conteenPj',
		//   component: () => import('@/leniuview/notice/conteenPj'),
		//   name: '食堂评价',
		//   id: 2105000,
		//   meta: { title: '食堂评价' ,roles:[2105000]}
		// },
		{
			path: 'log',
			component: () => import('@/leniuview/notice/log'),
			name: '系统日志',
			id: 2106000,
			meta: { title: '系统日志', roles: [2106000] }
		}
	]
}

export default noticeRouter
